import clsx from 'clsx';
import LinkNext, { LinkProps } from 'next/link';
import { HTMLAttributeAnchorTarget } from 'react';

const PADDINGS = {
  none: '',
  default: 'px-3 py-2',
  lg: 'px-6 py-2',
  xl: 'px-8 py-3',
  '2xl': 'px-12 py-4',
};

const PADDINGS_FULL_WIDTH = {
  none: '',
  default: 'w-full flex justify-center py-2',
  lg: 'w-full flex justify-center py-2',
  xl: 'w-full flex justify-center py-3',
  '2xl': 'w-full flex justify-center py-4',
};

type Colors = 'primary' | 'white';
type Variants = 'basic' | 'outline' | 'link';

type VariantColors = {
  [variant in Variants]: {
    [color in Colors]: string;
  };
};

const VARIANTS_COLORS: VariantColors = {
  basic: {
    primary:
      'border border-primary-filled-default bg-primary-filled-default hover:bg-primary-filled-hover rounded-md text-white-filled-default hover:border-primary-filled-hover',
    white:
      'border border-white-filled-default bg-white-filled-default hover:bg-white-filled-hover rounded-md text-black-filled-default hover:border-white-filled-hover',
  },
  outline: {
    primary:
      'border border-primary-filled-default rounded-md text-primary-filled-default hover:bg-primary-50',
    white:
      'border border-secondary-600 rounded-xl text-secondary-600 hover:bg-secondary-50',
  },
  link: {
    primary: 'text-primary-filled-default hover:underline',
    white: 'text-secondary-600 hover:underline',
  },
};

interface ButtonProps {
  children: React.ReactNode;
  color?: Colors;
  variant?: Variants;
  padding?: keyof typeof PADDINGS;
  width?: 'auto' | 'full';
  target?: HTMLAttributeAnchorTarget;
  rel?: string;
  className?: string;
  id?: string;
}

const Link = (props: ButtonProps & LinkProps) => {
  const {
    children,
    variant = 'basic',
    color = 'primary',
    padding = 'default',
    className = '',
    width = 'auto',
    ...rest
  } = props;
  return (
    <div
      className={clsx(
        VARIANTS_COLORS[variant][color],
        className,
        width === 'auto' && 'max-w-max'
      )}
    >
      <LinkNext
        {...rest}
        className={clsx(
          width === 'full' ? PADDINGS_FULL_WIDTH[padding] : PADDINGS[padding],
          className
        )}
      >
        {children}
      </LinkNext>
    </div>
  );
};

export default Link;
